module.exports = __webpack_public_path__ + "img/15_life_on_land_color.21cb4267.svg";